import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  IMAGE_BORDER_RADIUS,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import TextField from "@material-ui/core/TextField";
import FileHelper from "../../utils/FileHelper";
import {cloneDeep} from "lodash";
import SingleFilePicker, {
  ACCEPTED_IMAGE_MIMES,
  ACCEPTED_VIDEO_MIMES,
  FILE_TYPE_AUDIO,
  FILE_TYPE_IMAGE,
  FILE_TYPE_VIDEO,
  IMAGE_MAX_WIDTH_HEIGHT,
} from "../commons/SingleFilePicker";
import {ColorActivityForm, ColorTheme} from "src/styles/Colors";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import {CTA_TITLES} from "../../constants/ApiConstants";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import FieldSpace from "src/js/components/commons/FieldSpace";
import {getInitialFiles} from "src/js/utils/ValueHelper";
import {SNACKBAR_AUTO_HIDE_DURATION} from "src/js/components/commons/ViewHelper";
import DateTimeHelper from "src/js/utils/DateTimeHelper";
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import FormHelperText from "@material-ui/core/FormHelperText";

const useStyles = (theme) => ({
  formActivityCTA: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: BORDER_RADIUS,
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityForm,
  },
  viewCTA: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
    paddingBottom: 0,
  },
  videoPreview: {
    borderRadius: BORDER_RADIUS,
    border: '5px solid '+ ColorTheme,
    marginLeft: 32,
    marginRight: 32,
    // marginBottom: 2 * FIELD_SPACE,
    width: 320,
    height: 640,
    [theme.breakpoints.down('md')]: {
      width: 280,
      height: 560,
    }
  },
  imageCustomise: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    padding: 8,
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityForm,
    minWidth: 260,
    width: '100%',
    marginBottom: 16
  },
  imageCustomisePlaceholderImage: {
    width: 48,
    height: 48,
    borderRadius: IMAGE_BORDER_RADIUS,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

class ManageReelFront extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;

    this.maxVideoDuration = 60;
    this.maxAudioDuration = 60;
    if (activityData.mediaConfigs) {
      this.maxVideoDuration = activityData.mediaConfigs.maxVideoDuration;
      this.maxAudioDuration = activityData.mediaConfigs.maxBgAudioDuration;
    }
    this.maxDuration = Math.max(this.maxVideoDuration, this.maxAudioDuration);

    this.dateNow = new Date();
    this.dateMax = DateTimeHelper.getDateAfterYears(this.dateNow, 1);

    const mediaUrl = activityData.videoUrl || activityData.bgAudioUrl || activityData.s2ImageUrl;
    const mediaFiles = activityData.videoFiles || activityData.bgAudioFiles || activityData.s2ImageFiles;
    const mediaType = activityData.videoUrl ? FILE_TYPE_VIDEO : activityData.bgAudioFiles ? FILE_TYPE_AUDIO : FILE_TYPE_IMAGE;
    const mediaTUrl = activityData.videoTUrl;
    const isMediaDeleted = activityData.isVideoDeleted || activityData.isBgAudioDeleted || activityData.isSImageDeleted;

    const isSection2Expanded = true;
    const isSection1Expanded = false;
    this.state = {
      sections: [
        {id: 1, labelId: 'activity.manage.cta1Title', expand: isSection1Expanded},
        {id: 2, labelId: 'activity.manage.cta2Title', expand: isSection2Expanded, expandAlways: true},
      ],
      showValidationMsg: false,
      startAt: activityData.startAt instanceof Date ? activityData.startAt : DateTimeHelper.getDateFromDateString(activityData.startAt),
      description: activityData.description,
      s2ImageUrl: activityData.s2ImageUrl,
      s2ImageFiles: activityData.s2ImageFiles,
      isS2ImageDeleted: activityData.isS2ImageDeleted,
      bgAudioUrl: activityData.bgAudioUrl,
      bgAudioFiles: activityData.bgAudioFiles,
      isBgAudioDeleted: activityData.isBgAudioDeleted,
      videoUrl: activityData.videoUrl,
      videoFiles: activityData.videoFiles,
      isVideoDeleted: activityData.isVideoDeleted,

      mediaUrl: mediaUrl,
      mediaFiles: mediaFiles,
      isMediaDeleted: isMediaDeleted,
    };

    this.sImageInitialFiles = getInitialFiles(activityData.sImageFiles, activityData.sImageUrl, FILE_TYPE_IMAGE);
    this.initialVFiles = getInitialFiles(activityData.videoFiles, activityData.videoUrl, FILE_TYPE_VIDEO, activityData.videoTUrl);
    this.initialMediaFiles = getInitialFiles(mediaFiles, mediaUrl, mediaType, mediaTUrl);

    this.ctaTitles = CTA_TITLES;
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
  }

  componentWillUnmount() {
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  getData(excludeError) {
    const {activityData} = this.props;
    const {
      startAt,
      mediaUrl,
      mediaFiles,
      isMediaDeleted,
      description
    } = this.state;
    let videoUrl = activityData.videoUrl;
    let bgAudioUrl = activityData.bgAudioUrl;
    let s2ImageUrl = activityData.s2ImageUrl;
    let isVideoDeleted = false;
    let isBgAudioDeleted = false;
    let isS2ImageDeleted = false;
    let videoFiles = null;
    let bgAudioFiles = null;
    let s2ImageFiles = null;

    if (!excludeError) {
      if (this.isTitleIncorrect(description)
        || this.isMediaIncorrect()
        || !startAt || (!activityData.noEditStartAt && !DateTimeHelper.isDateAfter(startAt, this.dateNow))) {
        this.updateState({showValidationMsg: true});
        return false;
      }
    }

    if (!mediaUrl) {
      videoUrl = null;
      bgAudioUrl = null;
      s2ImageUrl = null;
      isVideoDeleted = true;
      isBgAudioDeleted = true;
      isS2ImageDeleted = true;
    }
    if (mediaFiles && mediaFiles.length > 0) {
      if (mediaFiles[0].type === FILE_TYPE_VIDEO) {
        videoFiles = mediaFiles;
      } else if (mediaFiles[0].type === FILE_TYPE_AUDIO) {
        bgAudioFiles = mediaFiles;
      } else {
        s2ImageFiles = mediaFiles;
      }
    }

    return {
      startAt,
      s2ImageUrl,
      s2ImageFiles,
      isS2ImageDeleted,
      bgAudioUrl,
      bgAudioFiles,
      isBgAudioDeleted,
      videoUrl,
      videoFiles,
      isVideoDeleted,
      description
    };
  }

  render() {
    const {
      startAt,
      description,
      showValidationMsg
    } = this.state;
    const {activityData, classes, isXS} = this.props;



    let startDateError = null;
    let mediaError = null;
    if (showValidationMsg) {
      if (!startAt) {
        startDateError = <FormattedMessage id='generic.validation.required'/>;
      } else if (!activityData.noEditStartAt && !DateTimeHelper.isDateAfter(startAt, this.dateNow)) {
        startDateError = <FormattedMessage id='activity.manage.startDateAfterCurrentDate'/>;
      }
      mediaError = this.isMediaIncorrect();
    }

    return (
      <div className={classes.viewColumnFullWidthNoCenter}>
        <div className={classes.formActivity}>
          <SectionHeaderView labelId={'activity.campaignStart'} />
          <div style={{marginLeft: -16}}>
            <MuiPickersUtilsProvider utils={MomentUtils} locale={'en'}>
              <div className={isXS ? classes.flexColumnNoCenter : classes.flexRowWrap}>
                <div style={{flex: 1, minWidth: 200, marginLeft: 16}}>
                  <DateTimePicker
                    inputVariant="filled"
                    variant="inline"
                    size="small"
                    fullWidth
                    autoOk
                    required={!activityData.noEditStartAt}
                    disablePast
                    InputProps={{disableUnderline: true}}
                    format="DD/MM/YYYY hh:mm A"
                    disabled={activityData.noEditStartAt}
                    id="startAt"
                    name="startAt"
                    invalidDateMessage={<FormattedMessage id='generic.invalidDateFormat'/>}
                    maxDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                    minDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                    label={<FormattedMessage id='activity.manage.startDate'/>}
                    minDate={this.dateNow}
                    maxDate={this.dateMax}
                    value={startAt}
                    onChange={(date) => {
                      this.updateState({showValidationMsg: false, startAt: date})
                    }}
                    keyboardbuttonprops={{
                      'aria-label': 'change date',
                    }}
                    error={startDateError}
                    helperText={startDateError}
                  />
                </div>
              </div>
            </MuiPickersUtilsProvider>
          </div>
          <FieldSpace multiplier={2}/>

          <SectionHeaderView labelId={'activity.selectMedia'} />

          <div className={isXS ? classes.flexRowNoCenter : classes.viewColumnFullWidthNoCenter1}>
            <SingleFilePicker
              key={'SFP1'}
              required
              hideDropzoneText={true}
              size={isXS ? 'xsmall' : 'small'}
              filesLimit={1}
              showPreviewsInDropzone={true}
              acceptedFiles={{...ACCEPTED_VIDEO_MIMES, ...ACCEPTED_IMAGE_MIMES}}
              maxFileSize={100*1024*1024}
              maxDuration={this.maxDuration}
              maxWidthOrHeight={IMAGE_MAX_WIDTH_HEIGHT}
              maxDurationMimes={{audio: this.maxAudioDuration, video: this.maxVideoDuration}}
              maxSizeMimes={{audio: 2*1024*1024, image: 20*1024*1024, video: 100*1024*1024}}
              aspectRatioMimes={{image: 1, video: 9/16}}
              aspectRatio={1}
              initialFiles={this.initialMediaFiles}
              onError={this.onErrorFiles}
              onChange={(files) => {
                this.onChangeFiles(files, 'mediaUrl');
              }}
              onDelete={(file) => {
                this.onDeleteFile(file, 'mediaUrl');
              }}
              error={mediaError}
            />
            {!isXS && mediaError ? <FormHelperText className={classes.helperErrorPadding}><FormattedMessage id={'activity.imageVideoRequired'}/></FormHelperText> : null}
            <FieldSpace vertical={isXS}/>

            <TextField
              multiline
              required
              rows={1}
              rowsMax={8}
              variant="filled"
              fullWidth
              size="small"
              type="text"
              id="description"
              name="description"
              label={<FormattedMessage id='activity.reelFrontTitle'/>}
              InputProps={{disableUnderline: true}}
              inputProps={{maxLength: 500}}
              value={description}
              onChange={this.onChange}
              error={showValidationMsg && this.isTitleIncorrect(description)}
              helperText={showValidationMsg && !(isXS && mediaError) && this.isTitleIncorrect(description) && <FormattedMessage id='generic.validation.required' />}
            />
          </div>
          {isXS && mediaError ? <FormHelperText className={classes.helperError}><FormattedMessage id={this.isTitleIncorrect(description) ? 'activity.imageOrVideoTextRequired' : 'activity.imageVideoRequired'}/></FormHelperText> : null}
          <FieldSpace />
        </div>

        {this.renderSnackBar()}
      </div>
    )
  }

  renderSnackBar() {
    const {showSnackbar, snackbarInfo} = this.state;
    if (showSnackbar) {
      const {snackbarMessageId, snackbarMessage, snackbarType} = snackbarInfo;
      const onClose = () => {
        this.setState({showSnackbar: false, snackbarInfo: null});
      };
      let message = snackbarMessage;
      if (!message && snackbarMessageId) {
        message = <FormattedMessage id={snackbarMessageId}/>;
      }
      return (
        <Snackbar open={message != null} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
          <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
            {message}
          </MuiAlert>
        </Snackbar>
      );
    }
  }

  showSnackbar(snackbarInfo) {
    if (snackbarInfo) {
      this.setState({showSnackbar: true, snackbarInfo});
    }
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} onToggle={this.onFormSectionToggle} />
    );
  }

  onFormSectionToggle = (section) => {
    const {sections} = this.state;
    const index = sections.indexOf(section);
    const eSections = cloneDeep(sections);
    eSections[index].expand = !eSections[index].expand;
    this.setState({sections: eSections});
  }

  isTitleIncorrect(title) {
    return (!title || title.trim().length === 0);
  }

  isMediaIncorrect() {
    const {
      mediaUrl,
      mediaFiles
    } = this.state;
    return !mediaUrl && (!mediaFiles || mediaFiles.length === 0);
  }

  onChange = (event) => {
    let value = event.target.value;
    if (event.target.name === 'sLink' || event.target.name === 's2Link') {
      value = value.trim();
    }
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

  onErrorFiles = (error) => {
    this.showSnackbar({
      snackbarMessage: error,
      snackbarType: "error",
    });
  };

  onChangeFiles(files, id) {
    const {
      mediaUrl,
    } = this.state;

    let eImageUrl = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    if (id === 'mediaUrl') {
      eImageUrl = mediaUrl;
      keyImageUrl = 'mediaUrl';
      keyImageFiles = 'mediaFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eImageUrl)) {
          lFileUrl = eImageUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    this.updateState({showValidationMsg: false, [keyImageUrl]: lFileUrl, [keyImageFiles]: lFiles});
  }

  onDeleteFile(file, id) {
    const {
      mediaUrl,
      mediaFiles,
    } = this.state;

    let eImageUrl = null;
    let eImageFiles = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    let keyIsImageDeleted = null;
    if (id === 'mediaUrl') {
      eImageUrl = mediaUrl;
      eImageFiles = mediaFiles;
      keyImageUrl = 'mediaUrl';
      keyImageFiles = 'mediaFiles';
      keyIsImageDeleted = 'isMediaDeleted';
    }

    let lFiles = [];
    let lFileUrl = eImageUrl;
    if (eImageFiles) {
      let index = 0;
      eImageFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
        index++;
      });
      lFiles = eImageFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eImageUrl)) {
      lFileUrl = null;
    }

    this.updateState({showValidationMsg: false, [keyImageUrl]: lFileUrl, [keyImageFiles]: lFiles, [keyIsImageDeleted]: true});
  }

  onChecked = (event) => {
    const value = event.target.checked;
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

}

ManageReelFront.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  user: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageReelFront.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
    user: state.admin.user,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageReelFront))
);
